import { useEffect, useState } from "react";
import ConfettiAnimation from "./ConfettiAnimation";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { CheckCircle2 } from "lucide-react";
import { safeGetItem, safeSetItem } from "@/lib/safeStorage";

export default function PWAInstallationSuccess() {
  const [showCelebration, setShowCelebration] = useState(false);

  useEffect(() => {
    // Check if running in PWA mode (standalone)
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;

    if (!isStandalone) {
      return; // Not in PWA mode, don't show celebration
    }

    // Check if this is the first time opening the PWA
    const hasSeenCelebration = safeGetItem("pwa_celebration_shown");

    if (!hasSeenCelebration) {
      // Show celebration for first-time PWA users
      setShowCelebration(true);

      // Mark as shown
      safeSetItem("pwa_celebration_shown", "true");

      // Auto-dismiss after 5 seconds
      setTimeout(() => {
        setShowCelebration(false);
      }, 5000);
    }
  }, []);

  if (!showCelebration) return null;

  return (
    <>
      <ConfettiAnimation duration={5000} onComplete={() => setShowCelebration(false)} />
      
      <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
        <Card className="w-full max-w-md bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 border-2 border-primary/40 shadow-[0_20px_60px_rgba(0,0,0,0.8),0_0_40px_rgba(59,130,246,0.3)] transform-gpu animate-in zoom-in-95 duration-500">
          <CardHeader className="text-center pb-3">
            <div className="flex justify-center mb-4">
              <CheckCircle2 className="w-20 h-20 text-green-500 animate-in zoom-in-50 duration-700" />
            </div>
            <CardTitle className="text-3xl font-bold bg-gradient-to-r from-primary via-blue-400 to-purple-500 bg-clip-text text-transparent">
              Welcome! 🎉
            </CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <div className="space-y-2">
              <p className="text-xl font-semibold text-foreground">
                Wega di Number Korsou
              </p>
              <p className="text-lg text-primary/90">
                (AI Prediction)
              </p>
            </div>
            
            <div className="pt-2 pb-1">
              <p className="text-muted-foreground">
                Successfully installed! You can now use the app offline and access it from your home screen.
              </p>
            </div>

            <div className="pt-2 border-t border-border/50">
              <p className="text-sm text-muted-foreground">
                Created by <span className="text-primary font-semibold">Cyrus Brands</span>
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                Need help? Call or WhatsApp: <span className="text-primary">+5999 512-2377</span>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
